import '../styles/Projects.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import RotatingText from './RotatingText';

export const projectData = [
  {
    title: 'A-Pujas a Puja Website',
    description: 'My first commercial website built with HTML and CSS.',
    link: 'https://github.com/coderarka2004/apandit.github.io',
  },
  {
    title: 'QUIZ APP',
    description: 'Responsive React quiz application.',
    link: 'https://react-quiz-koushani.netlify.app/',
  },
  {
    title: 'Low Harmonics E-Type Inverter',
    description: 'Power electronics project for harmonic reduction.',
    link: 'https://drive.google.com/drive/folders/1fLQSrejeUq2-1029ulim2Flyp4K2of0d?usp=drive_link',
  },
  {
    title: 'Smart Power Distribution',
    description: 'IoT based smart power monitoring and relay control.',
    link: 'https://drive.google.com/drive/folders/1-nSU0AlV_oRI8Srfv3Yro-sJrVlppFPH?usp=drive_link',
  },
  {
    title: 'Personal AI Desktop Assistant',
    description: 'Python voice assistant capable of desktop automation.',
    link: 'https://github.com/coderarka2004/AI-Desktop-Assistant',
  },
  {
    title: 'ML Cancer Detection',
    description: 'CNN based cancer detection from medical images.',
    link: 'https://github.com/coderarka2004/Cancer-Detection-ML',
  },
  {
    title: 'ML Lung Cancer Detection',
    description: 'CNN + GradCAM explainable lung cancer detection.',
    link: 'https://github.com/coderarka2004/Cancer-Detection-ML',
  },
];

export default function Projects() {
  return (
    <section className="projects" id="projects">

      <RotatingText
        texts={['My Projects', 'Featured Works', 'Recent Builds']}
        rotationInterval={3000}
        staggerDuration={0.04}
        splitBy="characters"
        className="animated-title"
      />

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        navigation
        pagination={{ clickable: true }}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        loop={true}
        breakpoints={{
          320: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 3,
          },
        }}
      >
        {projectData.map((project, index) => (
          <SwiperSlide key={index}>
            <div className="project-card">

              <h2>{project.title}</h2>

              <p>{project.description}</p>

              <a
                href={project.link}
                target="_blank"
                rel="noreferrer"
              >
                View Project →
              </a>

            </div>
          </SwiperSlide>
        ))}
      </Swiper>

    </section>
  );
}